<template>
  <div class="contact-wrapper">
    <h1>{{ $t("website.contact.contact") }}</h1>

    <div class="contact-card">
      <div class="left">
        <img
          src="@/assets/website/contact.jpg"
          title="Frederik Reiff, Kundenberater bei ChronoFox"
          alt="Porträt von Frederik Reiff, Kundenberater bei ChronoFox"
        />
      </div>
      <div class="right">
        <p class="headline">{{ $t("website.contact.here_for_you") }}</p>
        <p class="subtitle">Frederik Reiff</p>

        <p class="contact-info">
          Consultancy, Support or Feature-Ideas? <br />
          Feel free to approach me with any questions or suggestions.
          <br /><br />

          Your contact options:
          <br />
          <a href="mailto:info@chronofox.de"> E-Mail: info[at]chronofox.de</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "website",
});

const { t, locale } = useI18n();

import logo from "@/assets/logo/chronofox_wortbild_right.png";
useSeoMeta({
  title: t("website.contact.meta_title") + " | " + t("app_name"),
  description: t("website.contact.meta_description"),

  ogTitle: t("app_name") + " - " + t("website.contact.meta_title"),
  ogDescription: t("website.contact.meta_description"),
  ogLocale: locale.value ? locale.value : "de",
  ogType: "website",
  ogImage: logo,

  twitterCard: "summary_large_image",
  twitterTitle: t("website.contact.meta_title") + " | " + t("app_name"),
  twitterDescription: t("website.contact.meta_description"),
  twitterImage: logo,
  twitterSite: "@ChronoFoxApp",
});
</script>

<style scoped>
.contact-wrapper {
  min-height: 100vh;
  padding: 60px 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.contact-wrapper h1 {
  font-size: 2.5rem;
  margin-bottom: 40px;
}

.contact-card {
  max-width: 800px;
  width: 100%;
  padding: 30px;
  display: flex;
  gap: 20px;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(
    to bottom right,
    var(--orange-1) 70%,
    var(--yellow-orange-1) 100%
  );
  color: var(--t-white);
}

.left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.left img {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
}

.right {
  flex: 2;
  text-align: left;
}

.headline {
  font-size: 1.8rem;
  font-weight: bold;
}

.subtitle {
  font-size: 1.4rem;
  margin-bottom: 20px;
}

.contact-info {
  font-size: 1rem;
  line-height: 1.5;
}

.contact-info a {
  color: var(--t-white);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .contact-card {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }

  .right {
    text-align: center;
  }
}
</style>
